<template>
    <v-row no-gutters>
        <v-col cols="12" md="3" class="pe-1">
            <v-autocomplete
                label="Account"
                v-model="line.ledger_account_id"
                :rules="[isRequired]"
                @update:search-input="searchAccount"
                :items="ledgerAccounts"
                item-value="id"
                item-text="display_name"
                hide-details="auto"
                outlined
                dense
            >
            </v-autocomplete>
        </v-col>
        <v-col class="pe-1">
            <v-text-field
                label="Amount"
                :disabled="!currency"
                v-model="line.document_amount"
                :suffix="accountCurrencyCodeSuffix"
                :rules="[isRequired, isNumeric]"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col class="pe-1">
            <v-text-field
                label="Amount"
                :suffix="baseCurrencyCodeSuffix"
                disabled
                :value="baseAmount"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col class="pe-1">
            <v-text-field
                label="Amount"
                :suffix="ladgerAccountCurrencyCodeSuffix"
                disabled
                :value="accountAmount"
                background-color="disabled"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
        </v-col>
        <v-col cols="12" md="4" class="d-flex align-center">
            <v-text-field
                v-model="line.description"
                label="Description"
                dense
                outlined
                hide-details="auto"
            >
            </v-text-field>
                <v-btn icon @click="handleDeleteLine">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import { isRequired, isNumeric } from "./../../utils/validations"
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "DebitNoteFormLine",
    props: {
        value: Object,
        currency: Object,
        baseCurrency: Object,
        exchangeRates: Array,
        showAccountAmount: Boolean
    },
    data(){
        return {
            line: {...this.value}
        }
    },
    computed: {
        ...mapGetters({
            ledgerAccounts: "purchase/ledgerAccount/list",
            loading: "purchase/ledgerAccount/loading"
        }),
        accountCurrencyCodeSuffix() {
            return this.currency ? this.currency.code : null
        },
        baseCurrencyCodeSuffix() {
            return this.baseCurrency ? this.baseCurrency.code : null;
        },
        ladgerAccountCurrencyCodeSuffix() {
            return this.accountCurrency ? this.accountCurrency.code : null
        },
        //ledger account currency
        accountCurrency() {
            if(!this.account) return null;
            return this.account.currency
        },
        exchangeRate() {
            if(!this.currency) return null;
            return this.exchangeRates.find(exchangeRate => exchangeRate.currency_id == this.currency.id);
        },
        // ledger account
        account() {
            return this.ledgerAccounts.find(account => account.id == this.line.ledger_account_id);
        },
        baseAmount() {
            if(!this.exchangeRate) return 0;
            return this.line.document_amount * this.exchangeRate.customRate;
        },
        // retern object ledger account currency rate
        accountCurrencyExchangeRate() {
            if(!this.accountCurrency) return null;
            return this.exchangeRates.find(exchangeRate => exchangeRate.currency_id == this.accountCurrency.id)
        },
        // ledger amount calculate by (base amount / ledger currency rate)
        accountAmount() {
            if(!this.accountCurrencyExchangeRate) return 0;
            return this.baseAmount / this.accountCurrencyExchangeRate.customRate;
        }
    },
    watch: {
        line : {
            handler(line) {
                this.$emit("input", {...line});
            },
            deep : true
        },
        accountAmount(amount) {
            this.line.amount = amount;
        },
        baseAmount(amount) {
            this.line.base_amount = amount;
        },
        currency() {
            this.$emit("input", {...this.line});
        }
    },
    methods: {
        isRequired, isNumeric,
        ...mapActions({
            searchAccount: "purchase/ledgerAccount/search"
        }),
        handleDeleteLine() {
            this.$emit("deleteLine")
        }
    }
}
</script>

<style>

</style>